import { render, staticRenderFns } from "./tag-edit.vue?vue&type=template&id=8e34e824&scoped=true"
import script from "./tag-edit.vue?vue&type=script&lang=js"
export * from "./tag-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e34e824",
  null
  
)

export default component.exports